/* eslint-disable max-len */
// @flow
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import X from 'assets/icons/x.svg';
import classnames from 'classnames';
import styles from './style.module.scss';
import MatrixCardTable from '../../containers/MatrixCardTable/MatrixCardTable';
import { Button, P } from '../../components';
import actionTypes1 from '../../store/table/actionTypes1';
import actionTypes2 from '../../store/table2/actionTypes2';
import Legend from '../../components/Legend';
import actionTypes from '../../store/profile/actionTypes';
import useWindowDimensions from '../../utils/windowDemensions';
import MetaDecorator from '../../utils/MetaDecorator';
import { preflop } from '../../utils/MetaDecorator/meta';
import legendItems from '../../utils/legenda';

// const legendItems = [
//   { name: 'Raise Reraise', color: '#FF5F5F' },
//   { name: 'Raise Call', color: '#F6AB2A' },
//   { name: 'Raise Fold', color: '#5939B9' },
//   { name: 'Limp Raise', color: '#F69378' },
//   { name: 'Limp Call', color: '#FCD191' },
//   { name: 'Limp Fold', color: '#8A78BF' },
//   { name: 'Call', color: '#669635' },
//   { name: 'Call Call', color: '#2F500E' },
//   { name: 'Call Fold', color: '#9BD262' },
//   { name: 'Fold', color: '#AAB8BF' },
// ];

const CardTablePage = () => {
  const dispatch = useDispatch();
  const [isSecondTableVisible, setSecondTableVisible] = useState<boolean>(false);
  // data for first table
  const purple1 = useSelector((state) => state.table.purple);
  const purple2 = useSelector((state) => state.table2.purple);
  const legenda1 = useSelector((state) => state.table.legenda);
  const legenda2 = useSelector((state) => state.table2.legenda);
  const legendaEasy1 = useSelector((state) => state.table.easyLegenda);
  const legendaEasy2 = useSelector((state) => state.table2.easyLegenda);
  const doubleColor1 = useSelector((state) => state.table.doubleColor);
  const doubleColor2 = useSelector((state) => state.table2.doubleColor);
  const easyDoubleColor1 = useSelector((state) => state.table.easyDoubleColor);
  const easyDoubleColor2 = useSelector((state) => state.table2.easyDoubleColor);
  /// ///////////////////////////////////////
  /// ///////////////////////////////////////
  const situation1 = useSelector((state) => state.table.situation);
  const combination1 = useSelector((state) => state.table.combination);
  const highest1 = useSelector((state) => state.table.highestCard);
  const isSituationLoading1 = useSelector((state) => state.api.SET_SITUATION.loading);
  const isTableLoaded1 = useSelector((state) => state.api.SET_TABLE.loading);
  const selectedTs1 = useSelector((state) => state.table.ts);
  const selectedBB1 = useSelector((state) => state.table.bb);
  const selectedGgps1 = useSelector((state) => state.table.ggps);
  const selectedStake1 = useSelector((state) => state.table.stake);
  const selectedCards1 = useSelector((state) => `${state.table.card1}${state.table.card2}${state.table.card3}${state.table.card4}`);
  const firstPairCardTableFold1 = useSelector((state) => state.table.firstPairCardTableFold);
  const secondPairCardTableFold1 = useSelector((state) => state.table.secondPairCardTableFold);
  const isFirstPairCardTableFoldLoaded1 = useSelector((state) => state.api.SET_FIRST_PAIR.loading);
  // eslint-disable-next-line max-len
  const isSecondPairCardTableFoldLoaded1 = useSelector((state) => state.api.SET_SECOND_PAIR.loading);
  const [isPlo5, setPlo5] = useState<boolean>(sessionStorage.getItem('isPlo5') === 'true');
  const gameTable1 = useSelector((state) => state.table.gameTable);
  const gameTable2 = useSelector((state) => state.table2.gameTable);

  const [selectedTable1, setSelectedTable1] = useState<number>(1);
  const [tableData1, setTableData1] = useState<Array<any>>([]);

  const [easyRFI1, setEasyRFI1] = useState<boolean>(false);
  const [easyRFI2, setEasyRFI2] = useState<boolean>(false);
  const [smartRange1, setSmartRange1] = useState<boolean>(false);
  const [smartRange2, setSmartRange2] = useState<boolean>(false);

  const setTable1 = () => {
    dispatch({ type: actionTypes1.SET_TABLE, gameTable: gameTable1 });
  };
  const setGgps1 = (e) => {
    dispatch({ type: actionTypes1.SET_GGPS, payload: e });
  };
  const setPurple1 = () => dispatch({ type: actionTypes1.SET_PURPLE, payload: false });
  const setPurple2 = () => dispatch({ type: actionTypes2.SET_PURPLE_2, payload: false });
  const setLegenda1 = () => dispatch({
    type: 'SET_LEGENDA_SUCCESS',
    payload: {
      legenda: [], doubleColor: false, easyLegenda: [], easyDoubleColor: false,
    },
  });
  const setLegenda2 = () => dispatch({
    type: 'SET_LEGENDA2_SUCCESS',
    payload: {
      legenda: [], doubleColor: false, easyLegenda: [], easyDoubleColor: false,
    },
  });
  const setBB1 = (e) => {
    dispatch({ type: actionTypes1.SET_BB, payload: e });
  };
  // eslint-disable-next-line max-len
  const initTable1 = ({
    ts, isTrial, selectedBB, gameTable, isBBchanged = false, isGameTableChanged = false, ggps,
  }) => dispatch({
    type: actionTypes1.SET_SITUATION,
    payload: {
      ts, isTrial, selectedBB, gameTable, isBBchanged, isGameTableChanged, ggps,
    },
  });
  // eslint-disable-next-line max-len
  const changeTs1 = (e) => {
    dispatch({
      type: actionTypes1.SET_SITUATION,
      payload: {
        ts: e.value, selectedBB: selectedBB1, gameTable: gameTable1, ggps: selectedGgps1,
      },
    });
  };
  const setBBNoReplace1 = (e) => {
    dispatch({ type: actionTypes1.SET_BB, payload: e });
  };
  const setStake1 = (e) => dispatch({ type: actionTypes1.SET_STAKE, payload: e });
  // eslint-disable-next-line max-len
  const setFirstPairCardTableFold1 = (easy, smartRange) => dispatch({
    type: actionTypes1.SET_FIRST_PAIR, easy, gameTable: gameTable1, smartRange,
  });
  // eslint-disable-next-line max-len
  const setSecondPairCardTableFold1 = (easy, smartRange) => dispatch({
    type: actionTypes1.SET_SECOND_PAIR, easy, gameTable: gameTable1, smartRange,
  });

  const suit1 = useSelector((state) => state.table.suit);
  const setSuit1 = (e) => dispatch({ type: actionTypes1.SET_SUIT, payload: e });
  const suitQuality1 = useSelector((state) => state.table.suitQuality);
  const setSuitQuality1 = (e) => dispatch({ type: actionTypes1.SET_SUIT_QUALITY, payload: e });

  // data for second table
  /// ///////////////////////////////////////
  /// ///////////////////////////////////////
  /// ///////////////////////////////////////
  const situation2 = useSelector((state) => state.table2.situation);
  const combination2 = useSelector((state) => state.table2.combination);
  const isSituationLoading2 = useSelector(
    (state) => state.api.SET_SITUATION_2.loading,
  );
  const isTableLoaded2 = useSelector(
    (state) => state.api.SET_TABLE_2.loading,
  );
  const selectedTs2 = useSelector((state) => state.table2.ts);
  const selectedBB2 = useSelector((state) => state.table2.bb);
  const selectedGgps2 = useSelector((state) => state.table2.ggps);
  const highest2 = useSelector((state) => state.table2.highestCard);
  const selectedStake2 = useSelector((state) => state.table2.stake);
  const selectedCards2 = useSelector((state) => `${state.table2.card1}${state.table2.card2}${state.table2.card3}${state.table2.card4}`);
  const firstPairCardTableFold2 = useSelector((state) => state.table2.firstPairCardTableFold);
  const secondPairCardTableFold2 = useSelector((state) => state.table2.secondPairCardTableFold);
  // eslint-disable-next-line max-len
  const isSecondPairCardTableFoldLoaded2 = useSelector((state) => state.api.SET_SECOND_PAIR_2.loading);
  const isFirstPairCardTableFoldLoaded2 = useSelector(
    (state) => state.api.SET_FIRST_PAIR_2.loading,
  );

  const setGgps2 = (e) => {
    dispatch({ type: actionTypes2.SET_GGPS_2, payload: e });
  };

  const initTable2 = isSecondTableVisible ? ({
    // eslint-disable-next-line no-unused-vars
    ts, isTrial, selectedBB, gameTable, isBBchanged, isGameTableChanged, ggps,
  }) => {
    if (!isGameTableChanged && !isBBchanged) {
      dispatch({
        type: actionTypes2.SET_SITUATION_2,
        payload: {
          ts: selectedTs1, isTrial, selectedBB: selectedBB1, gameTable: gameTable1, isBBchanged: isPlo5, isGameTableChanged: false, ggps: selectedGgps1,
        },
      });
    } else {
      dispatch({
        type: actionTypes2.SET_SITUATION_2,
        payload: {
          ts, isTrial, selectedBB, gameTable, isBBchanged, isGameTableChanged, ggps,
        },
      });
    }
  } : '';

  const [selectedTable2, setSelectedTable2] = useState<number>(1);
  const [tableData2, setTableData2] = useState<Array<any>>([]);
  const setTable2 = () => dispatch({ type: actionTypes2.SET_TABLE_2, gameTable: gameTable2 });
  const setBB2 = (e) => dispatch({ type: actionTypes2.SET_BB_2, payload: e });
  // eslint-disable-next-line max-len
  const changeTs2 = (e) => dispatch({
    type: actionTypes2.SET_SITUATION_2,
    payload: {
      ts: e.value, selectedBB: selectedBB2, gameTable: gameTable2, ggps: selectedGgps2,
    },
  });
  const setBBNoReplace2 = (e) => dispatch({ type: actionTypes2.SET_BB_2, payload: e });
  const setStake2 = (e) => dispatch({ type: actionTypes2.SET_STAKE_2, payload: e });
  // eslint-disable-next-line max-len
  const setFirstPairCardTableFold2 = (easy, smartRange) => dispatch({
    type: actionTypes2.SET_FIRST_PAIR_2, easy, gameTable: gameTable2, smartRange,
  });
  // eslint-disable-next-line max-len
  const setSecondPairCardTableFold2 = (easy, smartRange) => dispatch({
    type: actionTypes2.SET_SECOND_PAIR_2, easy, gameTable: gameTable2, smartRange,
  });

  const suit2 = useSelector((state) => state.table2.suit);
  const setSuit2 = (e) => dispatch({ type: actionTypes2.SET_SUIT_2, payload: e });
  const suitQuality2 = useSelector((state) => state.table2.suitQuality);
  const setSuitQuality2 = (e) => dispatch({ type: actionTypes2.SET_SUIT_QUALITY_2, payload: e });

  const { user } = useSelector((state) => state.profile);
  const isTrial = user?.rate?.toLowerCase() === 'trial';

  const { width } = useWindowDimensions();

  const handleLegenda = (colors1: Array<string>, colors2: Array<string>) => {
    const arr = [colors1, colors2];
    const legendaSort = arr.reduce((p, c) => p.filter((e) => !c.includes(e)));
    const legenda = [...legendaSort, ...colors2].length === 0
      ? colors2 : [...legendaSort, ...colors2];
    return (
      legenda.map((color) => (
        {
          name: legendItems[color],
          color,
        }
      ))
    );
  };

  useEffect(() => {
    dispatch({ type: actionTypes.GET_PROFILE_INFO });
  }, []);

  useEffect(() => {
    if (selectedTable1 !== 4) {
      if (legenda1.length >= 1) {
        setLegenda1();
      }
    }
    if (selectedTable2 !== 4) {
      if (legenda2.length >= 1) {
        setLegenda2();
      }
    }
    if (selectedTable1 !== 2) {
      if (purple1) {
        setPurple1();
      }
    }
    if (selectedTable2 !== 2) {
      if (purple2) {
        setPurple2();
      }
    }
  }, [selectedTable1, selectedTable2]);

  useEffect(() => {
    if (isSecondTableVisible) return;
    setLegenda2();
  }, [isSecondTableVisible]);

  const clearCards = () => {
    dispatch({ type: actionTypes1.SET_CARD1, payload: '' });
    dispatch({ type: actionTypes1.SET_CARD2, payload: '' });
    dispatch({ type: actionTypes1.SET_CARD3, payload: '' });
    dispatch({ type: actionTypes1.SET_CARD4, payload: '' });
  };

  const clearCards2 = () => {
    dispatch({ type: actionTypes2.SET_CARD1_2, payload: '' });
    dispatch({ type: actionTypes2.SET_CARD2_2, payload: '' });
    dispatch({ type: actionTypes2.SET_CARD3_2, payload: '' });
    dispatch({ type: actionTypes2.SET_CARD4_2, payload: '' });
  };

  useEffect(() => {
    function checkPlo5() {
      const item = sessionStorage.getItem('isPlo5');
      setPlo5(item === 'true');
    }

    window.addEventListener('storage', checkPlo5);

    return () => {
      window.removeEventListener('storage', checkPlo5);
    };
  }, []);

  useEffect(() => {
    setGgps1('ps');
    clearCards();
    clearCards2();
    initTable1({
      ts: 'low', isTrial: isTrial || '', selectedBB1, gameTable: gameTable1,
    });
    setSelectedTable1(1);
    setSecondTableVisible(false);
  }, [isPlo5]);

  const compareIsAvailable = () => {
    const list = [
      'advanced', 'advancedAnnual', 'plo4', 'plo5', 'plo4plo5', 'plo4annual', 'plo5annual', 'plo4plo5annual',
    ];

    return list.includes(user?.rate?.toLowerCase());
  };

  return (
    <div className={styles.home}>
      <MetaDecorator
        description={preflop.description}
        title={preflop.title}
      />
      <div
        className={styles.matrixWrapper}
      >
        <div className={styles.allTheTables}>
          {
            (width > 1060) ? (
              <div className={styles.allTheTablesIndent} />
            ) : null
          }
          <div className={styles.preflop}>
            <div className={styles.infoWrapper}>
              {
                (width > 1060) ? (
                  <div className={styles.infoWrapperIndent} />
                ) : null
              }
              {
                (width > 1060) ? (
                  <div className={styles.infoWrapperIndent} />
                ) : null
              }
            </div>
            <div className={styles.tablesWrapper}>
              {/* <div */}
              {/*  className={styles.firstMatrix} */}
              {/* > */}
              <MatrixCardTable
                rate={isTrial || ''}
            // for situation table
                isLoaded={isTableLoaded2}
                situation={situation1}
                isSituationLoading={isSituationLoading1}
                selectedTs={selectedTs1}
                selectedBB={selectedBB1}
                selectedTable={selectedTable1}
                setSelectedTable={setSelectedTable1}
                tableData={tableData1}
                setTableData={setTableData1}
                selectedStake={selectedStake1}
                selectedCards={selectedCards1}
                setBB={setBB1}
                initTable={initTable1}
                changeTs={changeTs1}
                setStake={setStake1}
            // for card table
                setCard1={(e) => dispatch({ type: actionTypes1.SET_CARD1, payload: e })}
                setCard2={(e) => dispatch({ type: actionTypes1.SET_CARD2, payload: e })}
                setCard3={(e) => dispatch({ type: actionTypes1.SET_CARD3, payload: e })}
                setCard4={(e) => dispatch({ type: actionTypes1.SET_CARD4, payload: e })}
                setTable={setTable1}
                bbAndStake={`${selectedBB1} ${selectedStake1}`}
                setBBNoReplace={setBBNoReplace1}
                firstPairCardTableFold={firstPairCardTableFold1}
                secondPairCardTableFold={secondPairCardTableFold1}
                setFirstPairCardTableFold={setFirstPairCardTableFold1}
                setSecondPairCardTableFold={setSecondPairCardTableFold1}
                isFirstPairCardTableFoldLoaded={isFirstPairCardTableFoldLoaded1}
                isSecondPairCardTableFoldLoaded={isSecondPairCardTableFoldLoaded1}
            // for last table
                isTableLoaded={isTableLoaded1}
                combination={combination1}
                highestCard={highest1}
            // handleSuit
                suit={suit1}
                setSuit={setSuit1}
                setSuitQuality={setSuitQuality1}
                easyRFI={easyRFI1}
                setEasyRFI={setEasyRFI1}
                isPlo5={isPlo5}
                gameTable={gameTable1}
                suitQuality={suitQuality1}
                smartRange={smartRange1}
                setSmartRange={setSmartRange1}
                setGgps={setGgps1}
                ggps={selectedGgps1}
                sideAction={
                  ((compareIsAvailable()) && width > 1000 && !isSecondTableVisible) ? (
                    <Button
                      small
                      name={!isSecondTableVisible && 'Compare'}
                      onClick={() => {
                        setSecondTableVisible(!isSecondTableVisible);
                        // dispatch({ type: actionTypes2.CLEAR_REDUCER });
                        setBB2(selectedBB1);
                        setGgps2(selectedGgps1);
                        // changeTs2(selectedTs1);
                        setSelectedTable2(1);
                      }}
                      className={classnames(styles.showSecondTableBtn,
                        styles.matrixCompareBtn,
                        { [styles.closeTableBtn]: isSecondTableVisible })}
                      customBackground="#73B6CA"
                    >
                      {isSecondTableVisible && <img src={X} alt="X" />}
                    </Button>
                  ) : null
                }
              />
              {/* </div> */}
              {(isSecondTableVisible)
                ? (
                  <MatrixCardTable
              // for situation table
                    situation={situation2}
                    isSituationLoading={isSituationLoading2}
                    selectedTs={selectedTs2}
                    selectedBB={selectedBB2}
                    selectedTable={selectedTable2}
                    setSelectedTable={setSelectedTable2}
                    tableData={tableData2}
                    setTableData={setTableData2}
                    selectedStake={selectedStake2}
                    selectedCards={selectedCards2}
                    setBB={setBB2}
                    initTable={initTable2}
                    changeTs={changeTs2}
                    setStake={setStake2}
              // for card table
                    setCard1={(e) => dispatch({ type: actionTypes2.SET_CARD1_2, payload: e })}
                    setCard2={(e) => dispatch({ type: actionTypes2.SET_CARD2_2, payload: e })}
                    setCard3={(e) => dispatch({ type: actionTypes2.SET_CARD3_2, payload: e })}
                    setCard4={(e) => dispatch({ type: actionTypes2.SET_CARD4_2, payload: e })}
                    setTable={setTable2}
                    bbAndStake={`${selectedBB2} ${selectedStake2}`}
                    setBBNoReplace={setBBNoReplace2}
                    firstPairCardTableFold={firstPairCardTableFold2}
                    secondPairCardTableFold={secondPairCardTableFold2}
                    setSecondPairCardTableFold={setSecondPairCardTableFold2}
                    setFirstPairCardTableFold={setFirstPairCardTableFold2}
                    isSecondPairCardTableFoldLoaded={isSecondPairCardTableFoldLoaded2}
                    isFirstPairCardTableFoldLoaded={isFirstPairCardTableFoldLoaded2}
                    highestCard={highest2}
              // for last table
                    isTableLoaded={isTableLoaded2}
                    combination={combination2}
              // handleSuit
                    suit={suit2}
                    setSuit={setSuit2}
                    easyRFI={easyRFI2}
                    setEasyRFI={setEasyRFI2}
                    isPlo5={isPlo5}
                    gameTable={gameTable2}
                    setSuitQuality={setSuitQuality2}
                    suitQuality={suitQuality2}
                    smartRange={smartRange2}
                    setSmartRange={setSmartRange2}
                    setGgps={setGgps2}
                    ggps={selectedGgps2}
                    sideAction={
                      ((compareIsAvailable()) && width > 1000 && isSecondTableVisible) ? (
                        <Button
                          small
                          name={!isSecondTableVisible && 'Compare'}
                          onClick={() => {
                            setSecondTableVisible(!isSecondTableVisible);
                            // dispatch({ type: actionTypes2.CLEAR_REDUCER });
                            setBB2(selectedBB1);
                            setGgps2(selectedGgps1);
                            // changeTs2(selectedTs1);
                            setSelectedTable2(1);
                          }}
                          className={classnames(styles.showSecondTableBtn,
                            styles.matrixCompareBtn,
                            { [styles.closeTableBtn]: isSecondTableVisible })}
                          customBackground="#73B6CA"
                        >
                          {isSecondTableVisible && <img src={X} alt="X" />}
                        </Button>
                      ) : null
                    }
                  />
                )
                : ''}
              {
              ((compareIsAvailable()) && width < 1000) ? (
                <div className={styles.compareWrapper}>

                  <Button
                    small
                    name={!isSecondTableVisible && 'Compare'}
                    onClick={() => {
                      setSecondTableVisible(!isSecondTableVisible);
                      // dispatch({ type: actionTypes2.CLEAR_REDUCER });
                      // changeTs2(selectedTs1);
                      setSelectedTable2(1);
                    }}
                    className={classnames(styles.showSecondTableBtn,
                      { [styles.closeTableBtn]: isSecondTableVisible })}
                    customBackground="#73B6CA"
                  >
                    {isSecondTableVisible && <img src={X} alt="X" />}
                  </Button>
                </div>
              ) : null
            }
            </div>
          </div>
          {
            ((compareIsAvailable()) && width > 1000) ? (
              <div className={styles.allTheTablesIndent} />
            ) : null
          }
        </div>
        {
          (selectedTable1 === 4 || selectedTable2 === 4) ? (
            <div className={styles.legendWrapper}>
              {
                (easyRFI1 ? easyDoubleColor1 : doubleColor1)
                  || (easyRFI2 ? easyDoubleColor2 : doubleColor2) ? (
                    <div className={styles.wrapperSublegend}>
                      <P>IP</P>
                      <div className={styles.sublegend}>
                        <div className={styles.line} />
                      </div>
                      <P>OOP</P>
                    </div>
                  ) : null
              }
              {handleLegenda(easyRFI1 ? legendaEasy1 : legenda1,
                easyRFI2 ? legendaEasy2 : legenda2).map((item) => (
                  <Legend
                    key={item.name}
                    name={item.name}
                    color={item.color}
                  />
              ))}
            </div>
          ) : null
        }
        {
          ((selectedTable1 === 2 || selectedTable2 === 2) && (purple1 || purple2)) ? (
            <div className={styles.legendWrapper}>
              <Legend
                key="raiseFoldorFold"
                name="Raise Fold or Fold"
                color="rgb(89, 57, 185)"
              />
            </div>
          ) : null
        }
      </div>
    </div>
  );
};

export default CardTablePage;
